module.exports = __webpack_public_path__ + "img/photos-logo.73cdaa2a.png";